import { Link, Navigate, useParams } from 'react-router-dom';
import { useContent } from '../ContentContext';
import { packByCode } from '../data/packs';
import { PageHero, SectionHead, PackGrid } from '../components/Common';

// Catalogue pack page — mirrors the source site's product-details layout:
// image + spec content, then related packs from the same brand & category.
export default function PackDetails() {
  const { code } = useParams();
  const { brands = [], productImg } = useContent();

  const pack = packByCode(code);
  if (!pack) return <Navigate to="/" replace />;

  // Find which brand/category lists this code so we can resolve its image.
  let brand = null;
  let category = '';
  for (const b of brands) {
    for (const cat of ['basmati', 'biryani', 'rozana']) {
      if ((b.products?.[cat] || []).includes(pack.code)) { brand = b; category = cat; break; }
    }
    if (brand) break;
  }

  const image = brand ? productImg(brand, category, pack.code) : '';
  const related = brand
    ? (brand.products?.[category] || []).filter((c) => c !== pack.code).slice(0, 4)
    : [];

  return (
    <>
      <PageHero title={pack.name} image={brand?.image} />

      <section>
        <div className="container profile-grid">
          <div className="profile-image">
            {image ? <img src={image} alt={pack.name} /> : null}
          </div>

          <div className="profile-content">
            {pack.category ? <span className="section-tag">{pack.category}</span> : null}
            <h2>{pack.name}</h2>
            <p>{pack.description}</p>

            {pack.sections.map((s) => (
              <div key={s.label}>
                <h3 className="pick-title">{s.label}</h3>
                <ul className="feature-list">
                  {s.items.map((it) => (
                    <li key={it.text}>
                      <i className={`fas ${it.icon}`} /> {it.text}
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {pack.packing.length ? (
              <>
                <h3 className="pick-title">Available Packing</h3>
                <div className="packing-size">
                  {pack.packing.map((p) => <span key={p}>{p}</span>)}
                </div>
              </>
            ) : null}

            <div className="pack-cta">
              <Link className="btn-gold" to="/contact-us">Send Enquiry</Link>
              <Link className="product-btn" to="/products">Shop Products</Link>
            </div>
          </div>
        </div>
      </section>

      {related.length ? (
        <section className="grey-bg">
          <div className="container">
            <SectionHead title="Related Products" />
            <PackGrid brand={brand} category={category} codes={related} />
          </div>
        </section>
      ) : null}
    </>
  );
}
